<template>
  <form ref="agreement" class="page-agreement" @submit.prevent="onSubmit">
    <div class="title">纵购商城服务协议</div>
    <textarea ref="text" class="text" readonly>
    本协议是由佛山市联塑电子商务有限公司（佛山市联塑电子商务有限公司为纵购平台的版权所有者，以下简称“纵购”）向纵购平台商家（以下简称“您”或“商家”）共同签署，旨在通过纵购平台（https://www.ourchoice.cn/）促进您和消费者完成在线交易服务（下称“本服务”）。

    一、声明与承诺
    1、您确认，您在申请入驻纵购平台之前，已充分阅读、理解并接受本协议的全部内容，一旦您使用本服务，即表示同意遵循本协议的所有约定。
    2、您同意，纵购有权基于国家法律法规变化、业务调整、产品更新及维护交易秩序、保护消费者权益等需要，不时对本协议内容进行变更，并以在纵购网站（https://www.ourchoice.cn/）公告的方式予以公布，不再另行单独通知您；若您在本协议内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容以使用本服务；若您不同意修改后的协议内容，应停止使用本服务。
    3、您声明，您在同意接受本协议并注册开通纵购平台账号时，您是具有法律规定的完全民事权利能力和民事行为能力，能够独立承担民事责任的自然人、法人或其他组织；本协议内容不受您所属国家或地区的排斥。不具备前述条件的，您应立即终止注册或停止使用本服务。
    4、纵购平台规则是指包括在所有在纵购商家平台（https://www.ourchoice.cn/）规则已经发布及后续发布的全部规则、解读、公告等内容以及帮助中心内发布的各类规则、实施细则、产品流程说明、公告等。您有义务遵守纵购平台规则所发布的内容。

    二、入驻条件
    1、纵购平台商家入驻需满足以下要求：
    (1)	通过纵购平台完成的交易，商家均需使用“消费者支付货款直接到达商家账户”的收款方式；
    (2)	商家店铺必须开通在线客服功能；
    (3)	商家有义务积极配合处理消费者维权申请，遵守《消费者保障承诺》的规定；
    (4)	店铺类型为微商城/零售且店铺已完成企业认证；
    (5)	店铺具备售卖精选商品所需的相应资质；
    (6)	店铺购物门槛必须设置“粉丝/非粉丝均可购买”；
    (7)	店铺在售商品不低于5件。

    三、服务费用
    1、鉴于纵购平台为商家提供了曝光、营销推广等服务，且纵购平台为向商家提供该等服务付出了大量的成本，商家通过纵购平台完成的交易订单纵购将按照交易额的一定比例收取推广服务费。为避免歧义，双方进一步明确前述“完成订单”指通过纵购平台进行下单的交易。
    2、商家知悉，纵购平台有权根据业务规划及业务发展对上述收费费率及收费方式进行调整，届时商家如继续使用本服务的将按照最新的收费费率及收费方式执行。

    四、服务使用规则
    1、商品管理规则
    (1)	您可在微商城店铺对商品入驻纵购平台进行管理，如您选择关闭商品成交状态，将不会产生订单来源是纵购平台的订单；
    (2)	您申请入驻纵购平台不代表店铺商品将会在纵购平台进行展示，您的店铺商品只有满足纵购平台相关条件的情况下才会被收录、展示；
    (3)	您应保证您店铺的商品始终符合纵购平台的收录、展示条件，在商品不符合相关条件的情况下纵购平台对该商品的收录、展示将会失效。您确认由此产生的损失由您自行承担；
    (4)	您同意已收录至纵购平台的商品，纵购平台将自动适用符合条件的商品活动、积分、卡券等信息。
    2、消费者保障规则
    (1)	商品发货时间：您需在消费者支付订单后的72小时内发货，若是海外商品则发货时间可以视具体情况而定，您应在商品详情或说明页面明确告知消费者。
    (2)	您需保证售卖的商品为有合法来源且不侵犯他人权利。若您售卖的商品存在侵权或违反广告法等法律法规的规定，则纵购有权立即对商品进行下架、删除等处理。
    (3)	您确认，商品的下架或删除不免除您对已经付费的消费者承担发货、退换货及质保维修、维权投诉等责任。
    3、交易争议解决
    您与消费者因交易产生纠纷，可以通过自主协商、向法院起诉等方式解决。若消费者投诉至纵购平台，则纵购平台有权依据纵购平台的规则进行判定及处理，您确认该等处理无需经过您的事先同意且您应自愿遵照该处理结果。

    五、特别约定
    1、纵购平台可能会基于您店铺的运营、推广需要对您店铺后台通用设置的内容做一定的修改，您确认纵购平台基于前述原因进行的修改无需经过您的事先同意，您亦不会以此为理由追究纵购平台的任何责任。如：
    (1)	若店铺设置仅限粉丝购买，入驻纵购平台后该设置将无效，即非粉丝用户在纵购平台仍能正常购买；
    (2)	店铺商品在入驻纵购平台后将按照平台支付规则进行支付；
    (3)	纵购平台将按照平台规则决定是否展示购物车及商品评价。
    2、您一旦选择退出纵购平台，自您退出纵购平台之时，您将无法参与纵购平台的活动，并且您店铺的商品也不再在纵购平台进行收录、展示。您的每款商品每次入驻纵购平台成功后，您的店铺三十天内您不可主动退出，除非是纵购进行的下架行为。
    3、【纵购责任限制】纵购依照法律规定履行基础保障义务，但对于下述原因导致的协议履行障碍、履行瑕疵、履行延后或履行内容变更等情形，纵购并不承担相应的违约责任：
    (1)	因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；
    (2)	因电力供应故障、通讯网络故障等公共服务因素或第三人因素；
    (3)	在纵购已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
    4、【信息保证】纵购仅向您提供纵购平台服务，您了解纵购平台上的信息系您自行发布，鉴于纵购平台具备存在海量信息及信息网络环境下信息与实物相分离的特点，纵购无法逐一审查商品及/或服务的信息，无法逐一审查交易所涉及的商品及/或服务的质量、安全以及合法性、真实性、准确性，因此你应保证您发布的商品及/或服务不存在质量、安全等问题并对此独自承担责任。
    5、【调处决定】您理解并同意，在您与消费者因商品交易产生争议纵购进行调处的服务中，纵购平台的客服、工作人员并非专业人士，仅能以普通人的认知对用户提交的凭证进行判断。因此，除存在故意或重大过失外，您应遵照纵购对争议调处的决定且纵购对该等调处决定免责。

    六、信息发布与承诺
    1、【信息的发布】您声明并保证，您对您所发布的信息拥有相应、合法的权利。否则，纵购可对您发布的信息依法或依本协议进行删除或屏蔽。
    2、【禁止性信息】您应当确保您所发布的信息不包含以下内容：
    (1)	违反国家法律法规禁止性规定的；
    (2)	政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
    (3)	欺诈、虚假、不准确或存在误导性的；
    (4)	侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；
    (5)	侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；
    (6)	存在可能破坏、篡改、删除、影响纵购平台任何系统正常运行或未经授权秘密获取纵购平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；
    (7)	其他违背社会公共利益或公共道德或依据相关纵购平台协议、规则的规定不适合在纵购平台上发布的。
    3、【授权使用】对于您提供、发布及在使用纵购平台服务中形成的除个人信息外的文字、图片、视频、音频等非个人信息，在法律规定的保护期限内您免费授予纵购及其关联公司获得全球排他的许可使用权利及再授权给其他第三方使用并可以自身名义对第三方侵权行为取证及提起诉讼的权利。您同意纵购及其关联公司存储、使用、复制、修订、编辑、发布、展示、翻译、分发您的非个人信息或制作其派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内。

    七、赔偿责任
    1、如您的行为使纵购及/或其关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿纵购及/或其关联公司的上述全部损失。
    2、如您的行为使纵购及/或其关联公司遭受第三人主张权利，纵购及/或其关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿。
    3、如因您的行为使得第三人（包括但不限于消费者）遭受损失或您怠于履行纵购的调处决定，纵购及/或其关联公司出于社会公共利益保护或消费者权益保护目的，纵购有权立即锁定您的店铺提现。若您未在3个工作日进行赔付，则纵购有权扣除您的店铺余额或保证金账户余额以对消费者或者纵购进行赔偿。如您店铺余额或保证金账户中的款项不足以支付上述赔偿款项，纵购及/或关联公司可直接抵减您在纵购及/或其关联公司其它协议项下的权益，并可继续追偿。

    八、知识产权保护
    1、纵购平台中由纵购上传、制作、拥有的所有内容，包括但不限于著作、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计，均由纵购或其关联公司依法拥有知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。如您在纵购平台上传由您自行制作、拥有的内容，包括但不限于图片、资讯、资料、店铺设计等，均由您或其关联公司依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等；但如因您上传的由您自行制作、拥有的内容涉及侵犯纵购或其他任何第三方的合法权益的，您应自行对其侵权行为产生的纠纷进行处理，并对其侵权行为承担法律责任，且就由此给纵购造成的损失（包括但不限于纵购声誉的影响、纵购由此承担的连带责任（如有）等）进行赔偿。
    2、非经纵购或其关联公司书面同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表在纵购平台上程序或内容（仅限于由纵购上传、制作、拥有的所有内容，包括但不限于著作、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计等）；如您需使用著作权非纵购所有的内容，您应获得具体内容的著作权所有者的合法授权才能使用，如因您私自使用非自己所有的、且未经他人合法授权的著作、图片、档案、资讯、资料等内容的，由您自行承担责任，包括但不限于您自行对其侵权行为产生的纠纷进行处理，并对其侵权行为承担法律责任，且就由此给纵购造成的损失（包括但不限于纵购声誉的影响、纵购由此承担的连带责任（如有）等）进行赔偿。
    3、您使用纵购提供服务，即您自动授权纵购在纵购及纵购关联的公司网站、宣传资料、媒体渠道等页面及资料上无偿使用您品牌、商标等进行展示和宣传，但纵购不得用于有损您品牌的用途。
    4、尊重知识产权是您应尽的义务，如有违反，您应承担损害赔偿责任。

    九、法律适用、管辖或其他
    1、本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律，没有相关法律规定的，参照通用国际商业惯例和（或）行业惯例。
    2、如本协议的任何条款被视作无效或无法执行，则上述条款可被分离，其余条款则仍具有法律效力。
    3、本协议任何一方于另一方过失或违约时放弃本协议规定的权利的，不得视为其对一方的其他或以后同类之过失或违约行为弃权。
    4、本协议自您按照纵购平台入驻流程完成注册步骤或您使用本协议项下服务时生效。
    5、双方约定，一旦由本协议产生争议，由广东省 佛山市顺德区人民 法院管辖。


                                                                                                                                                                                            佛山市联塑电子商务有限公司
    </textarea>
    <button ref="btn" class="button" type="submit">同意并继续</button>
  </form>
</template>

<script>
export default {
  name: 'Agreement',
  methods: {
    open() {
      const otherHeight = 145
      const maxHeight = window.innerHeight - otherHeight
      const agreementDom = this.$refs.agreement
      const textDom = this.$refs.text
      let textHeight

      if (maxHeight < 680) {
        textHeight = maxHeight - 40
        textDom.style.height = textHeight + 'px'
        agreementDom.style.marginTop = (textHeight + otherHeight) * -0.5 + 'px'
      }

      agreementDom.style.display = 'block'
      this.$refs.btn.focus()
    },
    onSubmit() {
      this.$refs.agreement.style.display = 'none'
      this.$emit('agree')
    }
  }
}
</script>

<style lang="postcss">
.page-agreement {
  display: none;
  width: 960px;
  border: 4px solid #ccc;
  background-color: #f2f2f2;
  margin: -340px -480px;
  text-align: center;
  position: fixed;
  left: 50%;
  top: 50%;

  .title {
    font-size: 18px;
    padding: 10px 0;
  }

  .text {
    border: 1px solid #ccc;
    width: 932px;
    height: 535px;
    margin: 0 10px;
  }

  .button {
    width: 360px;
    height: 45px;
    background-color: #fabe00;
    border: none;
    border-radius: 5px;
    font-weight: 700;
    font-size: 16px;
    color: #fff;
    margin: 20px 0;
  }
}
</style>
